import { render } from "./NewCostReportsPage.vue?vue&type=template&id=4a0b5b80"
import script from "./NewCostReportsPage.vue?vue&type=script&lang=js"
export * from "./NewCostReportsPage.vue?vue&type=script&lang=js"

import "./NewCostReportsPage.vue?vue&type=style&index=0&id=4a0b5b80&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__